import React, { Component } from "react";

import "zrender/lib/svg/svg";
import echarts from "echarts/lib/echarts";
// 引入柱状图
import "echarts/lib/chart/pie";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import Util from "../util";

class SuperPie extends Component {
  componentDidMount() {
    const {legendData=[],seriesData=[]} =this.props;
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById("SuperPie"));
    } else {
      var myChart = echarts.init(document.getElementById("SuperPie"), null, { renderer: "svg" });
    }
    myChart.clear();
    myChart.resize()
    // 绘制图表
    myChart.setOption(SuperPieOption(seriesData,legendData));
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      if (window.isLess47) {
        var myChart = echarts.init(document.getElementById("SuperPie"));
      } else {
        var myChart = echarts.init(document.getElementById("SuperPie"), null, { renderer: "svg" });
      }

      // 绘制图表
      myChart.clear();
      myChart.resize()
      myChart.setOption(SuperPieOption(nextProps.seriesData, nextProps.legendData));
    }
  }
  componentWillUnmount() {
    var myChart = echarts.init(document.getElementById("SuperPie"));
    myChart.clear();
  }
  shouldComponentUpdate(nextProps = {}, nextState = {}) {
    const thisProps = this.props || {}, thisState = this.state || {};
    for (const key in nextProps) {
      if (thisProps[key] !== nextProps[key] ) {
        return true;
      }
    }
    for (const key in nextState) {
      if (thisState[key] !== nextState[key] ) {
        return true;
      }
    }
    
    return false;
}
  render() {
    return (     
        <div id="SuperPie" style={{ width: "100%", height: this.props.height }}></div>
    );
  }
}

export default SuperPie;
/*饼图Option*/
function SuperPieOption(seriesData,legendData) {
  const color=[];
  legendData.forEach(v => {
    const cor = Util.pieEchartsColorMap.get(v.replace(/[0-9\.]+%$/,'')) || '#796EE0';

    color.push(cor);
  });
  return {
    color,//: //["#F8515C", "#FF9653", "#796EE0", "#5BA3F6"],
    animation: window.isLess47,

    calculable: true,
    legend: {
      //  width:300,
      // left:20,
      right: 0,
      top: "center",
      orient: "vertical",
      data: legendData,//["货币基金15.0%", "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    20.0%", "进取股票25.0%", "稳健型债券40.0%"],
      itemGap: 6,
      itemWidth: 5,
      selectedMode: false,

      icon: "circle",
      formatter: function (name) {
        const percentageIndex=name.search(/[0-9\.]+%$/)
        const namaArr = [name.slice(0, percentageIndex), name.slice(percentageIndex)];
        return `{a|${namaArr[0]}}{b|${namaArr[1]}}`;
      },
      textStyle: {
        color: "#333",
        fontSize: "12px",
        width: 180,
        rich: {
          a: {
            align: "left",
            width: 100,
          },
          b: { align: "right", width: 80 },
        },
      },
    },
    series: [
      {
        minAngle: 20,
        type: "pie",
        hoverAnimation: false,
        radius: [34, 47],
        center: ["18%", "50%"],
        roseType: false,
        data:seriesData, 
        label: {
          normal: {
            show: false,
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        itemStyle: {
          normal: {
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
        silent: true,
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/components/PieEcarts.js